import React, { useEffect , useState } from 'react';
import {MDBContainer,} from 'mdb-react-ui-kit';
import BreadCrumbs from '../components/breadcrumbs';
import Banner from '../components/img_banner';
import DownContact from '../components/downcontact';
import Info from '../components/services_rcm_info';
import Desc from '../components/services_rcm_description';

import RCMcy from '../images/servicesMain_Banner/Revenue-cycle-management.webp';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
ReactGA.initialize('G-7WQFXCQFVP');

const RCM = () => {
  useEffect(() => {
    // change title of page
    document.title = 'Revenue Cycle Management | Medical Billing | AcerHealth';

    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
  }, []);

  // Set breadcrumb
  const [Breadcrumb, setBreadcrumb] = useState('Revenue Cycle Management');

  // Set Banner Title
   const [BannerTitle, setBannerTitle] = useState({title: "Revenue Cycle Management", subtitle: "We help healthcare providers maximize revenue by simplifying medical billing and speeding up collections for faster, easier payments.", img:`url(${RCMcy})`});

   // Set DownContact Heading
   const [DownContactTitle, setDownContactTitle] = useState({title: "We help medical professionals accelerate revenue collection quickly and efficiently. Contact us today to connect with an expert."});

 
 return (
    <>
    <Helmet>
        <title> Revenue Cycle Management Services | AcerHealth RCM</title>
        <link rel="canonical" href="https://acerhealth.com/services/revenue-cycle-management" />
        <meta name="description" content="AcerHealth improves cash flow, cuts claim denials, and boosts financial performance with end-to-end revenue cycle management." />
        <meta name="keywords" content="Revenue Cycle Management" />
      </Helmet>
        {/* <BreadCrumbs Breadcrumb ={Breadcrumb} /> */}
        <Banner BannerTitle ={BannerTitle} />
        <Desc />
        <Info />
        <DownContact DownContactTitle = {DownContactTitle}  />
    </>
  );
};
  
export default RCM;